import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, Moon } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-navy text-cream py-24 px-6" data-id="element-210">
      <div className="max-w-4xl mx-auto text-center" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-10 text-gold" data-id="element-213">
            Resultados Reales
          </h2>

          <div className="bg-navy-light/50 border border-gold/20 rounded-2xl p-8 md:p-12" data-id="element-214">
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8" data-id="element-215">
              <div className="flex flex-col items-center" data-id="element-216">
                <TrendingDown className="w-12 h-12 text-gold mb-3" data-id="element-217" />
                <span className="text-sm uppercase tracking-wider text-cream/70 font-semibold" data-id="element-218">
                  Cortisol
                </span>
              </div>
              <div className="hidden md:block w-px h-16 bg-gold/30" data-id="element-219"></div>
              <div className="flex flex-col items-center" data-id="element-220">
                <Moon className="w-12 h-12 text-gold mb-3" data-id="element-221" />
                <span className="text-sm uppercase tracking-wider text-cream/70 font-semibold" data-id="element-222">
                  Sueño Profundo
                </span>
              </div>
            </div>

            <p className="text-xl md:text-2xl font-serif italic leading-relaxed text-cream/90" data-id="element-223">
              "En solo 7 días, tu cortisol bajará y el de tu bebé también. Verás
              cómo los despertares de cada 45 minutos se transforman en bloques
              de 4 a 6 horas de sueño profundo, simplemente eliminando los
              disparadores de alerta que hoy mantienen a tu bebé en estado de
              guardia."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}